module.exports = __webpack_public_path__ + "img/industryScore4.e5b82c64.svg";